/**
 * Brand configuration — single source of truth.
 *
 * Name locked: "Safe and Sorted" (May 2026).
 * Tagline: "Health and Safety sorted in minutes".
 *
 * DO NOT hard-code the brand name anywhere else in the codebase.
 * Always reference BRAND.name.
 */

export const BRAND = {
  // Hard-coded (was env-overridable). The Netlify build had
  // VITE_BRAND_NAME=App, which printed "Generated by App" on every PDF.
  name: 'Safe and Sorted',
  // Legal entity that owns and operates the platform. Used in the Terms page,
  // RAMS disclaimer footer, partner agreement footer, email footers and any
  // contract / receipt copy.
  // Incorporated 10 May 2026 via 1st Formations.
  // Companies Act 2006 s.82 requires the company number to appear on
  // business letters, websites, order forms and emails — keep it surfaced
  // wherever legalEntity appears.
  legalEntity: 'Safe and Sorted Ltd',
  companyNumber: '17214001',
  companyJurisdiction: 'England and Wales',
  registeredOffice: '71-75 Shelton Street, Covent Garden, London, WC2H 9JQ',
  tagline: 'Health and Safety sorted in minutes',
  // Palette — green + ink-navy direction (May 2026).
  // Per-tenant brand colour overrides primary in the customer's view via
  // organisations.brand_colour, but never replaces danger / warn.
  colour: {
    primary: '#1E293B',
    primaryDeep: '#0F172A',
    primaryLight: '#CBD5E1',
    primaryPale: '#E2E8F0',
    grey: '#CCCCCC',
    ink: '#0F172A',
    inkSoft: '#475569',
    bg: '#FAF7F2',
    success: '#16A34A',
    warn: '#BF8E3D',
    danger: '#B0413E',
  },
} as const;

export type Brand = typeof BRAND;
